export default function debounce( func, timeout = 100 ) {
	let _func = null;
	return ( ...args ) => {
		clearTimeout( _func );
		_func = setTimeout( () => {
			func( ...args );
		}, timeout );
	};
}
